import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Modal } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'

import NoReturnableOrderContent from './NoReturnableOrderContent/NoReturnableOrderContent'
import { titleReason } from './reasons'
import * as Styles from './styles'

const OrderErrorModal = ({ show, onClose }) => {
  const { t, i18n } = useTranslation()
  const { context } = useContext(AppContext)
  const customMessages = context.merchantInfo?.preferences?.custom_messages

  const getOrderErrorTitle = () => {
    const isReturnableReason = titleReason(customMessages)[context.orderInfo?.is_returnable_reason]?.(i18n.language)
    const defaultReason = titleReason(customMessages).default(i18n.language)

    return isReturnableReason || defaultReason
  }

  return (
    <Modal
      show={show}
      title={getOrderErrorTitle()}
      onClose={onClose}
      size="m"
      actions={
        <Button fullWidth onClick={onClose}>
          {t('Aceptar')}
        </Button>
      }
    >
      <Styles.Container>
        <NoReturnableOrderContent
          reason={context.orderInfo.is_returnable_reason}
          merchant={context.merchantInfo}
          customTextReasons={customMessages}
          disabledByRuleMessage={context.orderInfo?.disabled_by_rule_message}
        />
      </Styles.Container>
    </Modal>
  )
}

export default OrderErrorModal
